import React from "react";

/**
 * WatchHero.jsx
 * - Uses uploaded hero/photo at /mnt/data/Screenshot 2025-11-15 222244.png
 * - Left product block, vertical carousel indicators, right large image
 * - Pure CSS, responsive
 */

const HERO_IMG = "https://i.postimg.cc/NjR1gXDD/young-tender-curly-girl-holding-documents-removebg-preview.png";

export default function HeroCard32() {
  return (
    <>
      <section className="watch-hero" aria-label="Latest watch collection hero">
        <div className="watch-inner">

          {/* left product column */}
          <div className="watch-left">  <div className="watermark">UPSC</div>
            <div className="watch-badge">Courses</div>

            <div className="watch-title-wrap">
              <h2 className="watch-title">UPSC Mains <br/>Batches</h2>

              {/* vertical indicators */}
              <div className="watch-indicators" aria-hidden>
                <span className="dot-cm-hc32 big" />
                <span className="dot-cm-hc32 small active" />
                <span className="dot-cm-hc32 big" />
              </div>
            </div>

            <p className="watch-price">Batches Starting  <span className="price">Soon</span></p>

            <div className="watch-actions">
              <a className="btn-outline" href="#shop">Enrol Now</a>
            </div>
          </div>

          {/* right big image area */}
          <div className="watch-right" role="img" aria-label="Watch showcase image" style={{ backgroundImage: `url('${HERO_IMG}')` }}>
            {/* floating product card (example) */}
            <div className="floating-card" aria-hidden>
              <div className="steps-cm-hc32">350</div>
              <div className="steps-cm-hc32-label">Foot Steps</div>
            </div>
          </div>

        </div>

        {/* decorative big watermark text behind left area */}
      
      </section>

      <style>{`
/* ---------- BASE ---------- */
.watch-hero {
  position: relative;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #111;
  overflow: hidden;
  background: #fafafa;
  padding: 48px 6%;
}

/* inner layout: left content / right image */
.watch-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 520px;
  gap: 30px;
  align-items: center;
  position: relative;
}

/* left column */
.watch-left {
  position: relative;
  z-index: 2;
  padding-right: 20px;
}

.watch-badge {
  color: #666;
  font-weight:700;
  margin-bottom: 18px;
}

/* title row with indicators */
.watch-title-wrap {
  display:flex;
  gap:20px;
  align-items:flex-start;
}
.watch-title {
  font-size: clamp(2rem, 4.2vw, 3.2rem);
  margin: 0;
  line-height: 1.03;
  font-weight: 900;
  color: #111;
  max-width: 56%;
}

/* vertical indicators to left of title (mimic screenshot) */
.watch-indicators {
  display:flex;
  flex-direction:column;
  gap: 12px;
  align-items:center;
  margin-top: 12px;
}
.dot-cm-hc32 {
  display:block;
  border-radius: 50%;
  background: #222;
  opacity: 0.14;
}
.dot-cm-hc32.big { width: 10px; height: 10px; }
.dot-cm-hc32.small { width: 8px; height: 8px; opacity:0.6; }
.dot-cm-hc32.small.active { background: #111; opacity:1; }

/* price and CTA */
.watch-price { margin-top: 26px; color:#666; font-weight:600; }
.price { color: #1b2b58; font-weight:900; }

.watch-actions { margin-top: 28px; }
.btn-outline {
  display:inline-block;
  padding:12px 20px;
  border-radius:6px;
  border: 2px solid #111;
  text-decoration:none;
  color:#111;
  font-weight:700;
}

/* right image area */
.watch-right {
  height: 520px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  position: relative;
  box-shadow: 0 20px 60px rgba(16,24,40,0.08);
  display:flex;
  align-items:center;
  justify-content:center;
  overflow: visible;
}

/* floating product card on right */
.floating-card {
  position: absolute;
  top: 22%;
  left: 18%;
  background: white;
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow: 0 12px 30px rgba(0,0,0,0.12);
  display:flex;
  align-items:center;
  gap:10px;
  transform: translateY(-10px);
  animation: float 6s ease-in-out infinite;
}
.steps-cm-hc32 { font-weight:900; color:#1b2b58; font-size:1.1rem; }
.steps-cm-hc32-label { font-size:0.8rem; color:#666; }

/* watermark behind */
.watermark {
  position: absolute;
  left: 6%;
  top: 40%;
  transform: translateY(-50%);
  font-size: 18vw;
  font-weight:900;
  color: rgba(0,0,0,0.035);
  white-space: nowrap;
  pointer-events: none;
  z-index: 0;
}

/* floating animation */
@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
  100% { transform: translateY(0); }
}

/* responsive */
@media (max-width: 1100px) {
  .watch-inner { grid-template-columns: 1fr 420px; }
  .watch-right { height: 420px; }
  .watch-title { max-width: 100%; }
  .watermark { font-size: 40vw; left: 50%; transform: translate(-50%,-50%); text-align:center; }
}
@media (max-width: 720px) {
  .watch-inner { grid-template-columns: 1fr; gap: 18px; }
  .watch-right { order: 1; height: 360px; }
  .watch-left { order: 2; padding-top: 8px; }
  .watch-title { font-size: 1.6rem; }
 
  .watch-indicators { position: absolute; left: -20px; top: 40px; }
}

/* small polish */
.btn-outline:hover { transform: translateY(-4px); box-shadow: 0 12px 30px rgba(16,24,40,0.08); }
      `}</style>
    </>
  );
}
